// extracted by mini-css-extract-plugin
export default {"container":"style_container__Z4kij","date":"style_date__xY2YF","summaryCell":"style_summaryCell__xiFMg","content":"style_content__Gh0p2"};